// extracted by mini-css-extract-plugin
export var list = "Lightbox-module--list--+TkEr";
export var video = "Lightbox-module--video--V2jFL";